import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
const FULL = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
const WET = 100;
const DRY = 60;

const color = (v) => (v < DRY ? "#d97706" : v < WET ? "#94a3b8" : "#0f766e");

export function plantingWindow(rain) {
  const starts = rain.map((v, i) => (v >= WET && rain[(i + 11) % 12] < WET ? i : -1)).filter((i) => i >= 0);
  if (!starts.length) {
    const wettest = rain.indexOf(Math.max(...rain));
    return rain.every((v) => v >= WET)
      ? `Hujan relatif merata sepanjang tahun (semua bulan ≥ ${WET} mm). Tanam dapat dijadwalkan fleksibel; hindari puncak hujan (${FULL[wettest]}).`
      : `Tidak ada bulan dengan curah hujan ≥ ${WET} mm. Penanaman memerlukan penyiraman/irigasi dan kajian teknis.`;
  }
  const best = starts.reduce((a, b) => (dryRun(rain, b) > dryRun(rain, a) ? b : a));
  return `Perkiraan awal musim hujan: ${FULL[best]}. Tanam bibit di awal musim hujan agar akar berkembang sebelum musim kering berikutnya.`;
}

function dryRun(rain, start) {
  let n = 0;
  for (let k = 1; k <= 12 && rain[(start - k + 12) % 12] < WET; k++) n++;
  return n;
}

export function RainCalendar({ cal, testid = "rain-calendar" }) {
  if (!cal) return <p className="text-xs text-slate-500" data-testid={`${testid}-empty`}>Kalender tanam belum tersedia — titik lokasi lahan belum ditentukan atau data cuaca belum dapat diambil.</p>;
  const data = cal.monthlyRainMm.map((v, i) => ({ m: MONTHS[i], v }));
  return (
    <div data-testid={testid}>
      <p className="font-semibold text-slate-800">Kalender Tanam — curah hujan bulanan{cal.period ? ` (rata-rata ${cal.period})` : ""}</p>
      <div className="h-48 mt-2">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 4, right: 4, left: -16, bottom: 0 }}>
            <XAxis dataKey="m" tick={{ fontSize: 11 }} interval={0} />
            <YAxis tick={{ fontSize: 11 }} />
            <Tooltip formatter={(v) => [`${v.toLocaleString("id-ID")} mm`, "Curah hujan"]} />
            <Bar dataKey="v" radius={[4, 4, 0, 0]}>{data.map((d) => <Cell key={d.m} fill={color(d.v)} />)}</Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="flex flex-wrap gap-3 text-[11px] text-slate-600 mt-1">
        <span><i className="inline-block w-2.5 h-2.5 rounded-sm bg-teal-700 mr-1" />Basah ≥ {WET} mm</span>
        <span><i className="inline-block w-2.5 h-2.5 rounded-sm bg-slate-400 mr-1" />Lembap {DRY}–{WET} mm</span>
        <span><i className="inline-block w-2.5 h-2.5 rounded-sm bg-amber-600 mr-1" />Kering &lt; {DRY} mm</span>
      </div>
      <p className="mt-2 text-emerald-900" data-testid={`${testid}-window`}>{plantingWindow(cal.monthlyRainMm)}</p>
      <p className="text-[11px] text-slate-500 mt-1">{cal.note} Batas bulan kering &lt; 60 mm mengikuti Permentan 49/2014; ambang awal musim hujan ≥ 100 mm/bulan adalah asumsi perencanaan umum yang perlu dikonfirmasi dengan kondisi lapangan.</p>
    </div>
  );
}
